export function formatComponentName(code: string, name: string) {
  return code.replace(
    /export default function Component/g,
    `export function ${name}`
  )
}
